export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas por pagar"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen de facturas por pagar a proveedores"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver detalles"])},
          "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
          "total_num_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Facturas"])},
          "percent_receivable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["% Pagado"])},
          "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto total"])},
          "total_amount_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto pagado"])},
          "chart_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["% pagado"])},
          "payable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por pagar"])}
        }
      }
    }
  })
}